export const filterAgrupations = 'filterAgrupations';
export const filterBrands = 'filterBrands';
export const filterModels = 'filterModels';
export const filterTransmission = 'filterTransmission';
export const filterEnergies = 'filterEnergies';
export const filterZones = 'filterZones';

export const filterKm = 'filterKm';
export const filterPowerMax = 'filterPowerMax';
export const filterPriceMax = 'filterPriceMax';

export const filterRegistrationDate = 'filterRegistrationDate';
export const filterPlate = 'filterPlate';
export const filterBatch = 'filterBatch';

export const filterFavorite = 'filterFavorite';
export const filterBidden = 'filterBidden';
export const filterVehiclesBid = 'filterVehiclesBid';

export const filterOrder = 'filterOrder';

export const filterStates = 'filterStates';
export const filterBuyer = 'filterBuyer';
export const filterStadisticsBuyers = 'filterStadisticsBuyers';
export const filterDatePurchaseFrom = 'filterDatePurchaseFrom';
export const filterDatePurchaseTo = 'filterDatePurchaseTo';
export const filterYearPurchase = 'filterYearPurchase';
export const filterMonthPurchase = 'filterMonthPurchase';
export const filterTransportState = 'filterTransportState';

export const filterDealers = 'filterDealers';
export const filterComercialProducts = 'filterComercialProducts';
export const filterVIN = 'filterVIN';
export const filterFinancialOperation = 'filterFinancialOperation';
export const filterDatePurchaseOptionFrom = 'filterDatePurchaseOptionFrom';
export const filterDatePurchaseOptionTo = 'filterDatePurchaseOptionTo';
export const filterWarrantyExtension = 'filterWarrantyExtension';

export const Busqueda = 'Busqueda';
export const dateStart = 'dateStart';
export const dateEnd = 'dateEnd';
export const status = 'status';
export const Solicitante = 'Solicitante';
export const channelCode = 'channelCode';
